import { createFileRoute } from "@tanstack/react-router";
import AdminEventDetail from "@/pages/AdminEventDetail";

export const Route = createFileRoute("/admin/events/$id/")({
  component: AdminEventDetail,
});
